// extracted by mini-css-extract-plugin
export default {"swiper-initialized":"style_swiper-initialized__gUvUk","swiper-button-next":"style_swiper-button-next__xAlfK","swiper-button-prev":"style_swiper-button-prev__a7c5K"};